

export const DisplayMsg = {
    emailExistGoToLogin: "Oops! Looks like you have already registered for an event on Film Platform with this email address. Please login to your event using the event invitation code with <a href='/event-login/?t=p'>this link</a>",
    emailExistGoToEmailLogin: "Oops! Looks like you have already registered for an event on Film Platform with this email address. Please login to your event using the event invitation code with <a href='/event-login/?t=e'>this link</a>",
}